module.exports = __webpack_public_path__ + "media/bell-ring.5c461aca.mp3";